'use client'

import { useClipboard } from '@/shared/hooks/useClipboard'
import { Check } from 'lucide-react'
import type { PropsWithChildren } from 'react'
import Icon from '../Icon'
import type { LoadingButtonProps } from '../LoadingButton'
import LoadingButton from '../LoadingButton'

export type ClipboardButtonIconProps = Omit<LoadingButtonProps, 'isLoading'> & {
    isLoading?: boolean
    textToCopy: string
}

const ClipboardButtonText = ({
    children,
    textToCopy,
    intent = 'secondary',
    isLoading = false,
    ...props
}: PropsWithChildren<ClipboardButtonIconProps>) => {
    const { copyStatus, onSetCopyStatus } = useClipboard()

    const onCopyToClipboard = () => {
        onSetCopyStatus(textToCopy)
    }

    return (
        <LoadingButton
            onClick={onCopyToClipboard}
            className="flex items-center gap-1"
            intent={intent}
            isLoading={isLoading}
            {...props}
        >
            {copyStatus === 'inactive' ? children : <Icon icon={Check} />}
        </LoadingButton>
    )
}

export default ClipboardButtonText
